<template>
    <div class="cz2__sb-selector-wrapper">
        <alert-modal
            :showCloseButton="false"
            @close="close"
            @confirm="close"
            class="cz2__sb-selector"
        >
            <!--
            <div class="cz2__sb-chevron-left" />
            <div class="cz2__sb-chevron-right" />
            -->

            <swiper :center="true" class="cz2__sb-modal-content" :showScrollbar="true">
                <div
                    class="cz2__sb-pop-logo-main"
                />

                <div class="cz2__sb-modal-heading cz2__font-sb">
                    {{modalSuperHeading}}
                </div>

                <div v-if="modalCopy && modalCopy.length > 0" class="cz2__sb-modal-copy cz2__font-inter">
                    {{modalCopy}}
                </div>

                <custom-swiper
                    :slidesPerView="'1'"
                    :allowFreeMode="false"
                    :show-mask="false"
                    :space-between="0"
                    :has-mobile-bullets="true"
                    :has-mobile-arrows="false"
                >
                    <template v-slot:slides>
                        <img
                            v-for="pack in packs"
                            :key="pack.code"
                            :src="pack.image"
                            :alt="pack.name"
                            height="250"
                            width="auto"
                            class="swiper-slide"
                        >
                    </template>
                </custom-swiper>

                <div v-if="!isKiosk" class="cz2__sb-buttons-wrapper">
                    <sb-button
                        @click="enableSb"
                        heightVariant="small"
                        :width="275"
                    >
                        {{modalOk}}
                    </sb-button>

                    <sb-button
                        variant="tertiary"
                        heightVariant="small"
                        :width="275"
                        @click="navigateToSBPage"
                    >
                        {{modalPacks}}
                    </sb-button>

                    <button
                        class="cz2__no-thanks-button"
                        @click="close"
                    >
                        {{ modalCancel }}
                    </button>
                </div>

                <div v-if="isKiosk" class="cz2__sb-buttons-wrapper">
                    <sb-button
                        @click="enableSb"
                        heightVariant="small"
                        :width="275"
                    >
                        {{modalOk}}
                    </sb-button>

                    <sb-button
                        variant="tertiary"
                        heightVariant="small"
                        :width="275"
                        @click="close"
                    >
                        {{modalCancel}}
                    </sb-button>
                </div>
            </swiper>
        </alert-modal>
    </div>
</template>

<style lang="scss">
    @use 'sass:math';
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__attach-packs-info {
            .cz2__attach-packs-price,
            .cz2__modal-popup__copy {
                color: #040504;
                font-family: 'Open Sans', sans-serif;
                line-height: 20px;
            }

            .cz2__attach-packs-price {
                margin: 8px 0 16px 0;

                @include font(h1);
                font-size: 24px;

                text-transform: uppercase;
            }

            .cz2__btn--black,
            .cz2__btn--black:hover {
                height: 60px;
                font-size: 22px;
            }
        }
    }

    #cz2.cz2 {
        .cz2__sb-selector-wrapper {
            .cz2__sb-stars {
                position: absolute;
                top: 0;
                transform: scale(0.5);
            }

            .cz2__modal-popup__body {
                background-image: url("../assets/images/branded/sb-final/SB-Background-Pattern-1_M@2x.jpg");
                background-size: cover;

                border-image-source: url("../assets/images/branded/sb-final/SB-Border 1_M@2x.webp");

                border-width: 40px;
                border-image-width: 40px;
                border-image-slice: 80 fill;
                border-image-repeat: stretch;

                padding: 40px 40px;

                @include respond-below(sm) {
                    margin: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100%;
                    border-radius: 0;

                    .cz2__sb-modal-copy {
                        font-size: 14px;
                    }

                    .swiper-container-outer {
                        width: 210px;
                        height: 210px;
                        margin-bottom: 0;
                    }
                }

                @include respond-above(sm) {
                    background-image: url("../assets/images/branded/sb-final/SB-Background-Pattern-1_D@2x.jpg");
                    border-image-source: url("../assets/images/branded/sb-final/SB-Border 1_D@2x.webp");
                }
            }

            .cz2__sb-modal-content {
                position: relative;

                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #fff;
                height: 100%;
                overflow: hidden;
                -webkit-overflow-scrolling: touch;
                .swiper-wrapper {
                    .cz2__sb-pop-logo-main {
                        flex: 0 0 auto;

                        margin-top: 0px;
                        margin-bottom: 10px;

                        margin-left: auto;
                        margin-right: auto;

                        height: 65px;

                        background-image: url("../assets/images/branded/sb-final/SB-PopYourself Logo Intro M@2x.webp");
                        background-size: contain;
                        background-position: center;
                        background-repeat: no-repeat;

                        @include respond-above(sm) {
                            height: 71px;

                            background-image: url("../assets/images/branded/sb-final/SB-PopYourself Logo Intro D@2x.webp");
                        }
                    }
                }
            }

            .cz2__sb-chevron-left {
                position: absolute;

                width: 42px;
                height: 42px;

                background-image: url("../assets/images/branded/sb-final/SB-Chevron L_M@2x.webp");
                left: 1px;
                background-size: contain;
                background-repeat: no-repeat;

                top: 50%;
                margin-top: -21px;

                z-index: 10;

                @include respond-above(sm) {
                    background-image: url("../assets/images/branded/sb-final/SB-Chevron L_D@2x.webp");
                    left: 3px;
                }
            }

            .cz2__sb-chevron-right {
                position: absolute;

                width: 42px;
                height: 42px;

                background-image: url("../assets/images/branded/sb-final/SB-Chevron L_M@2x.webp");
                right: 1px;
                background-size: contain;
                background-repeat: no-repeat;

                transform: rotate(180deg);

                top: 50%;
                margin-top: -21px;

                z-index: 10;

                @include respond-above(sm) {
                    background-image: url("../assets/images/branded/sb-final/SB-Chevron L_D@2x.webp");
                    right: 2px;
                }
            }

            .cz2__sb-modal-heading {
                font-size: 28px;
                font-weight: 700;
                margin-bottom: 8px;
                color: #112344;
            }

            .cz2__sb-modal-copy {
                font-family: 'Proxima Nova', sans-serif;
                font-size: 16px;
                font-weight: 400;
                max-width: 300px;
                margin: 0 auto;
                color: #112344;
            }

            .flex-height {
                flex: 1;
            }

            .swiper-container-outer {
                margin-top: 20px;
                margin-bottom: 20px;
                width: 250px;

                .swiper-container {
                    padding: 0;
                }
            }

            .cz2__sb-buttons-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                width: calc(100vw - 120px);
                max-width: 340px;
                margin-left: auto;
                margin-right: auto;

                button {
                    margin-bottom: 8px;
                }

                button:last-child {
                    margin-bottom: 0;
                }
            }
        }

        .cz2__no-thanks-button {
            font-family: 'Proxima Nova', sans-serif;
            font-size: 16px;
            font-weight: 600;
            color: #112344;
            text-decoration: underline;
            border: none;
            cursor: pointer;
            padding: 4px;
            margin-top: 0px;

            &:focus {
                outline: none !important;
                box-shadow: 0 0 0 2px color(sbGold);
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__sb-selector-wrapper {
            .cz2__no-thanks-button {
                display: none;
            }

            .cz2__sb-modal-copy {
                padding-bottom: 24px;
            }

            .cz2__sb-buttons-wrapper {
                padding-bottom: 32px;
            }

            .cz2__modal-popup__body {
                background-image: url("../assets/images/branded/sb-final/SB-Background-Pattern-1_K@2x.jpg");
                border-image-source: url("../assets/images/branded/sb-final/SB-Border 1A_K@2x.webp");
            }

            .cz2__sb-modal-content {
                .cz2__sb-pop-logo-main {
                    height: 90px;

                    background-image: url("../assets/images/branded/sb-final/SB-PopYourself Logo Intro K@2x.webp");
                }
            }

            .cz2__sb-chevron-left {
                background-image: url("../assets/images/branded/sb-final/SB-Chevron L_K@2x.webp");
                left: 3px;
            }

            .cz2__sb-chevron-right {
                background-image: url("../assets/images/branded/sb-final/SB-Chevron L_K@2x.webp");
                right: 2px;
            }
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';
    import CustomSwiper from './ui/CustomSwiper.vue';
    import SbButton from './SbButton.vue';
    import Swiper from './ui/Swiper.vue';

    // eslint-disable-next-line no-unused-vars
    import { getBrandedAssetUrl, getAssetUrl } from '../helpers/branding';

    export default {
        components: {
            AlertModal,
            CustomSwiper,
            SbButton,
            Swiper,
        },

        computed: {
            customAttributes() {
                return this.$store.state.customizer.globalSettings.blueprint.custom;
            },

            settingsController() {
                return this.$store.state.customizer.globalSettings;
            },

            modalHeading() {
                return this.customAttributes['fun-sb-attach-pack-modal-heading'];
            },

            modalSuperHeading() {
                return this.customAttributes['fun-sb-attach-pack-modal-super-heading'] || this.$t('DONT_MISS_OUT');
            },

            modalCopy() {
                return this.customAttributes['fun-sb-attach-pack-modal-copy'];
            },

            modalOk() {
                return this.customAttributes['fun-sb-attach-pack-modal-ok'];
            },

            modalPacks() {
                return this.customAttributes['fun-sb-attach-pack-modal-packs'];
            },

            modalCancel() {
                return this.customAttributes['fun-sb-attach-pack-modal-cancel'];
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            packs() {
                const all = [];

                for (let i = 0; i < 20; i += 1) {
                    const name = this.customAttributes[`fun-sb-attach-pack-modal-slide${i}-name`];
                    const asset = this.customAttributes[`fun-sb-attach-pack-modal-slide${i}-asset`];

                    if (name && asset) {
                        all.push({
                            code: name,
                            name,
                            image: getAssetUrl(this.settingsController, `fun-sb-attach-pack-modal-slide${i}-asset`, true),
                        });
                    }
                }

                return all;
            },

            price() {
                return `$${this.packs[0].price}`;
            },

            getBrandedAssetUrl() {
                return getBrandedAssetUrl;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('setShowSbSelectorModal', false);
            },
            enableSb() {
                this.$emit('confirm');
                this.close();
            },
            navigateToSBPage() {
                window.location = this.customAttributes['fun-sb-attach-pack-modal-packs-url'];
            },
        },
    };
</script>
